module.exports = __webpack_public_path__ + "img/01.06b0905b.png";